<template>
    <div class="create-project">
        <a href="javascript:;" class="project-link mini-link" @click.stop="openForm">
            <i class="demo-icon icon-calendar-plus-o"></i>
        </a>
        <div class="tooltip">
            {{ title }}
        </div>

        <template v-if="isOpened && createProjectFormSchema">
            <b-modal centered hide-footer :visible="true" @hide="closeForm">
                <div class="modal-header">
                    <h3>{{ messages.title_form }}</h3>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <ui-input-field :field="createProjectFormSchema.project_name_field"
                                        v-model="projectName"
                        ></ui-input-field>
                    </div>
                    <div class="btns-row">
                        <button class="btn btn-std" @click.stop="createProject"> {{ messages.create }}</button>
                        <button class="btn btn-std" @click.stop="closeForm"> {{ messages.cancel }}</button>
                    </div>
                </div>
            </b-modal>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import uiInputField from "vueComponents/ui-elements/fields/Inputr";

    /**
     * Компонент для создания пустого проекта для текущего пользователя
     *
     * @vuedoc
     * @module vue:components/CreateProject
     * @exports vue:components/CreateProject
     */

    export default {
        name: 'create-project',
        selector: '.create-project',

        props: [
            'title',
            'lang'
        ],

        components: {
            'ui-input-field': uiInputField,
        },


        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {boolean} isOpened - Флаг (открыта/закрыта) форма
         * @property {string} projectName - Название проекта
         */
        data() {
            return {
                isOpened: false,
                projectName: ''
            }
        },

        computed: {
            ...mapGetters('project', [
                'createProjectFormSchema',
            ]),

            messages() {
                return this.createProjectFormSchema ? this.createProjectFormSchema.messages : {};
            }
        },

        /**
         * Обновляем название проекта
         */
        watch: {
            createProjectFormSchema() {
                this.projectName = this.createProjectFormSchema.project_name_field.value;
            }
        },

        methods: {

            /**
             * Открывает форму создания проекта
             *
             * @method openForm
             */
            openForm() {
                this.isOpened = true;
                this.$store.dispatch('project/getCreateProjectFormSchema', this.lang);
            },

            /**
             * Закрывает форму создания проекта
             *
             * @method closeForm
             */
            closeForm() {
                this.isOpened = false;
            },

            /**
             * Создает пустой проект с заданным именем
             *
             * @method createProject
             */
            createProject() {
                this.$store.dispatch('project/createProject', this.projectName);
            }
        }
    }
</script>
